import safeAwait from '../../../../lib/safeAwait'
import errorHelper, { httpHandler } from '../../../../lib/errorHelper'

const fetchCategoryOptions = async (actions, params) => {
  const [error, payload] = await safeAwait(
    actions.fetchCategoryOptions(params).then(httpHandler)
  )
  const errorMessage = errorHelper.parseErrorMessage(error)
  if (errorMessage) {
    return [{ message: errorMessage, params }]
  }

  return [undefined, payload]
}

export default fetchCategoryOptions
